/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ComplianceFindingFalsePositiveRequest
 */
export interface ComplianceFindingFalsePositiveRequest {
    /**
     * 
     * @type {string}
     * @memberof ComplianceFindingFalsePositiveRequest
     */
    reason?: string;
}

/**
 * Check if a given object implements the ComplianceFindingFalsePositiveRequest interface.
 */
export function instanceOfComplianceFindingFalsePositiveRequest(value: object): value is ComplianceFindingFalsePositiveRequest {
    return true;
}

export function ComplianceFindingFalsePositiveRequestFromJSON(json: any): ComplianceFindingFalsePositiveRequest {
    return ComplianceFindingFalsePositiveRequestFromJSONTyped(json, false);
}

export function ComplianceFindingFalsePositiveRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ComplianceFindingFalsePositiveRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function ComplianceFindingFalsePositiveRequestToJSON(json: any): ComplianceFindingFalsePositiveRequest {
    return ComplianceFindingFalsePositiveRequestToJSONTyped(json, false);
}

export function ComplianceFindingFalsePositiveRequestToJSONTyped(value?: ComplianceFindingFalsePositiveRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'reason': value['reason'],
    };
}

